/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { screen } from "@monsma/XDL/Helpers";
import { xBaseTheme } from "@monsma/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        buttonProps: {
            hoverMode: undefined,
            css: css`
                border-width: 0;
                background: unset !important;
                height: auto;
                padding: 5px;
                margin: 0;

                &:disabled {
                    opacity: 0.33;
                }

                svg {
                    color: ${getColor("common.ui9")};
                }

                &:not(:disabled) {
                    &:hover svg {
                        color: ${getColor("common.ui3")};
                    }
                }
            `,
        },
        selectProps: {
            cssOverrides: {
                formInputWrapper: css`
                    width: 65px;
                    margin-right: 30px;

                    ${screen("lt", "sm")} {
                        margin-right: 0;
                        width: auto;
                        flex: 1;
                    }
                `,
                formField: css`
                    align-items: center;
                `,
                inputSelect: css`
                    ${getProp("theme.formField.defaultProps.cssOverrides.inputSelect")};
                    padding-right: 10px;
                `,
            },
            labelProps: {
                size: 13,
                lineHeight: "22px",
                weight: "normal",
                ellipsis: false,
                css: css`
                    width: auto;
                    padding: 0;
                    margin-right: 13px;
                    flex: 0 0 auto;
                `,
            },
            sizeVariant: "small",
        },
        currentField: {
            cssOverrides: {
                formField: css`
                    width: auto;
                `,
                formInputWrapper: css`
                    width: 35px;
                    margin-right: 10px;
                `,
                inputSelect: css`
                    ${getProp("theme.formField.defaultProps.cssOverrides.inputSelect")}
                    text-align: center;

                    /* Chrome, Safari, Edge, Opera */
                    &::-webkit-outer-spin-button,
                    &::-webkit-inner-spin-button {
                        -webkit-appearance: none;
                        margin: 0;
                    }

                    /* Firefox */
                    &[type="number"] {
                        -moz-appearance: textfield;
                    }
                `,
            },
            sizeVariant: "small",
        },
        finalPageText: {
            size: 13,
            lineHeight: "22px",
            css: css`
                flex: 0 0 auto;

                > span {
                    font-weight: bold;
                    margin-left: 5px;
                }
            `,
        },
        cssOverrides: {
            pagination: css`
                ${screen("lt", "md")} {
                    justify-content: center;
                }
            `,
            linkList: css`
                &&& {
                    margin: 0;
                }

                ${screen("lte", "md")} {
                    width: auto;
                }

                ${screen("lt", "sm")} {
                    width: 100%;

                    ul {
                        width: 100%;
                        justify-content: center;

                        li {
                            &:first-child {
                                button {
                                    padding-left: 0;
                                }
                            }

                            &:last-child {
                                button {
                                    padding-right: 0;
                                }
                            }
                        }
                    }
                }
            `,
            perPageSelect: css`
                &&& {
                    margin: 0;

                    ${screen("lte", "md")} {
                        width: auto;
                    }

                    ${screen("lt", "sm")} {
                        width: 100%;
                        margin: 0 0 15px;
                    }
                }
            `,
        },
    },
} as xBaseTheme["pagination"];
